import Seo from "@/components/Seo";
import { useSite } from "@/context/SiteContext";

export default function Terms() {
  const { config } = useSite();
  return (
    <>
      <Seo
        title="Terms of use | Commercial Solar ROI — by Coastal Energy"
        description="The terms that govern your use of this website, including limits on estimates, concepts and professional advice."
      />
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">TERMS OF USE · OCTOBER 2026</span>
          <h1>Plain terms for this website.</h1>
        </div>
      </section>
      <section style={{ paddingBottom: 30 }}>
        <div className="wrap prose" data-testid="terms-content">
          <h2>What this site is</h2>
          <p>
            {config.brand} is the brand voice of Commercial Solar ROI — Coastal Energy's dedicated commercial solar platform,
            providing project assessments, financial calculators, utility-bill reviews, and solar-plus-storage planning. Lawrence
            Williams leads commercial sales. It provides educational content, interactive planning concepts and a way to request an
            assessment. Using the site does not create a contractor or engineering relationship; the applicable project services are
            delivered by Coastal Energy under its own agreements.
          </p>

          <h2>Concepts are not engineering</h2>
          <p>
            Rooftop layouts, panel counts, coverage percentages, 3D scenes and photo overlays are <strong>illustrative concepts</strong> built
            from the inputs you supply. They do not measure slope, shade, structural capacity or code compliance, and they are not an
            equipment schedule. Any live map or solar-data feature is subject to data-source coverage and terms, with attribution shown
            where required.
          </p>

          <h2>No professional advice</h2>
          <p>
            Calculators, including the commercial financial dashboard, produce <strong>scenario arithmetic from the numbers you enter</strong> —
            not tax, legal, accounting or engineering advice. Tax figures depend on eligibility, ownership, timing and rules that change;
            a qualified tax adviser must confirm any incentive outcome. Payback figures are not IRR, and nothing here guarantees savings,
            offsets, valuation or production.
          </p>

          <h2>Assessments and availability</h2>
          <p>
            Submitting a request saves your record and, where recipients are configured, notifies the project team. An assessment is a
            review, not a commitment to install, a price quote or a guarantee of service availability in your area. Service coverage is
            confirmed during your assessment.
          </p>

          <h2>Acceptable use</h2>
          <p>
            Upload only files you are authorized to share. Do not submit another person's information without their permission, attempt to
            access admin or private records, or submit automated or duplicate requests. We may rate limit or reject submissions that fail
            validation.
          </p>

          <h2>Intellectual property</h2>
          <p>
            The site's design, text, scenes and code belong to the operator. Tesla, Powerwall, Solar Roof and SPAN are trademarks of their
            respective owners; references are for compatibility discussion, not affiliation or endorsement.
          </p>

          <h2>Limitation of liability and changes</h2>
          <p>
            The site is provided "as is". To the extent permitted by law, the operator is not liable for decisions made on the basis of
            concept outputs or calculator scenarios. These terms may be updated; the date above will change when they do. These terms
            are governed by the laws of the State of Florida, without regard to conflict-of-law rules.
          </p>

          <h2>Contact</h2>
          <p>Questions about these terms: call {config.phone} or use the contact form.</p>
        </div>
      </section>
    </>
  );
}
